import { STORAGE_KEY } from './storage-keys'

export type SelectionOptions = {
  vision?: boolean
  dental?: boolean
}

/**
 * Clears persisted plan selections from sessionStorage.
 * - vision: clears 'visionPlanId' and 'visionPlanSelected'
 * - dental: clears 'dentalPlanId' and 'dentalPlanSelected'
 * If no options are provided, clears both vision and dental selections.
 */
export function clearSelections(
  options: SelectionOptions = { vision: true, dental: true }
) {
  const { vision = false, dental = false } = options ?? {}
  try {
    if (vision) {
      sessionStorage.removeItem(STORAGE_KEY.VISION_PLAN_ID)
      sessionStorage.removeItem(STORAGE_KEY.VISION_PLAN_SELECTED)
    }
    if (dental) {
      sessionStorage.removeItem(STORAGE_KEY.DENTAL_PLAN_ID)
      sessionStorage.removeItem(STORAGE_KEY.DENTAL_PLAN_SELECTED)
    }
  } catch {
    // non-blocking: sessionStorage may be unavailable
  }
}
